<template>
  <b-modal v-model="inputVal.modal"
           centered
           hide-header
           hide-footer
  >
    <div class="success-modal__body d-flex flex-column align-items-center">
      <span class="success-modal__msg mb-4">{{ inputVal.msg }}</span>

      <b-button variant="primary"
                @click="handleClickEnter"
      >
        確定
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import vModelMixin from '@/mixins/v-model';

export default {
  mixins: [vModelMixin],
  components: {
    BButton,
  },
  methods: {
    handleClickEnter() {
      this.inputVal.modal = false;
      this.$bvModal.hide('modal-delivery-input');
    },
  },
};
</script>

<style scoped lang="scss">
.success-modal {
  &__body {
    padding: 12px;
  }

  &__msg {
    font-size: 1.25rem;
    font-weight: 500;
    color: #636d77;
  }
}
</style>
